import { monitorLoadingError } from './obsoleteApi.js';
export function loadFooter(outlet) {
    const observer = new MutationObserver(async (mutationList, observer) => {
        for (const mutation of mutationList) {
            if (mutation.type === 'childList') {
                await outlet.firstChild.updateComplete;
                monitorLoadingError(import('../elements/element-footer.js'));
                observer.disconnect();
            }
        }
    });
    observer.observe(outlet, {
        attributes: false,
        childList: true,
        subtree: false,
    });
}
//# sourceMappingURL=footerLoader.js.map